import api from './api';
import { EmailAccount, OutboundTemplate, OutboundUsageRouting } from '../types';

export type OutboundState = {
  accounts: EmailAccount[];
  templates: OutboundTemplate[];
  routing: OutboundUsageRouting[];
};

export const outboundService = {
  getState: async (): Promise<OutboundState> => {
    const response = await api.get('/admin/outbound/state');
    return response.data?.data || { accounts: [], templates: [], routing: [] };
  },
  saveState: async (state: OutboundState): Promise<OutboundState> => {
    const response = await api.put('/admin/outbound/state', state);
    return response.data?.data || state;
  },
  testEmail: async (payload: { accountId: string; to: string; subject?: string; body?: string }) => {
    const response = await api.post('/admin/settings/outbound/test-email', payload);
    return response.data?.data || response.data;
  },
};
